"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketEvents = void 0;
var SocketEvents;
(function (SocketEvents) {
    SocketEvents["MessageUpdates"] = "MESSAGE_UPDATES";
    SocketEvents["MessageSubscribe"] = "MESSAGE_SUBSCRIBE";
    SocketEvents["MessageUnsubscribe"] = "MESSAGE_UNSUBSCRIBE";
    SocketEvents["RoomUpdates"] = "ROOM_UPDATES";
    SocketEvents["RoomSnapshot"] = "ROOM_SNAPSHOT";
})(SocketEvents = exports.SocketEvents || (exports.SocketEvents = {}));
